// Placeholder team utilities for play-in bracket slots.
// Play-in seeds (7/8) are undecided before April 14, so 4 of 8 R1 matchups
// show placeholder labels instead of real team names.

/** Play-in placeholder team names (short codes stored in the DB). */
const PLACEHOLDER_NAMES = new Set(['W7', 'W8', 'E7', 'E8']);

/**
 * Returns true if the given team name is a placeholder (undecided play-in seed).
 */
export function isPlaceholderTeam(name: string | null | undefined): boolean {
  if (!name) return false;
  return PLACEHOLDER_NAMES.has(name);
}
